import { isCurrentCultureRightToLeft } from 'owa-localize';
import { getSpacesOptions } from 'owa-timestream-options';
import getAssetsBoundingRect from './getAssetsBoundingRect';
import getCanvasBounds from './getCanvasBounds';
import isUsingToolbox from './isUsingToolbox';
import { shouldShowExpandedToolbox } from 'owa-timestream-toolbox-common';

/**
 * Grid size for timestream canvas to keep asset positioning & alignment consistent.
 *
 * NOTE: 16 has not yet been applied to all places in the canvas as we origingally started off with 10.
 * Future references to the grid size should refer to this constant.
 * VSO 106812 - Asset Guides + Canvas arrangment improvements
 */
const CANVAS_GRID_SIZE = 16;

export default function getDefaultPanAndZoom(initialLoad?: boolean) {
    const { top, left, right } = getAssetsBoundingRect();

    // Add some padding so we don't land the assets on top of the toolbox
    const hasToolbox = isUsingToolbox();
    const toolboxExpanded = initialLoad
        ? !getSpacesOptions().toolboxCollapsed
        : shouldShowExpandedToolbox();
    const paddingWithToolbox = CANVAS_GRID_SIZE * 5;
    const paddingX = !hasToolbox
        ? CANVAS_GRID_SIZE
        : toolboxExpanded
        ? paddingWithToolbox * 3
        : paddingWithToolbox;
    const paddingY = !hasToolbox ? CANVAS_GRID_SIZE : paddingWithToolbox;

    let x = 0;
    if (isCurrentCultureRightToLeft()) {
        if (!isNaN(right)) {
            const { width } = getCanvasBounds();
            x = width - paddingX - right;
        }
    } else {
        if (!isNaN(left)) {
            x = paddingX - left;
        }
    }
    const y = isNaN(top) ? 0 : paddingY - top;

    return { pan: { x, y }, zoom: 1 };
}
